<!-- Sidepanel Right Search Customer -->
<aside [ngClass]="{'active':  userService.priorityUpdateModal.isModalOpen }" class="footer-sidepanel footer-sidepanel--customer-search">
    <div class="footer-sidepanel__header">
        <h5><i class="fa-light fa-pen-to-square"></i>Update Priority for {{ userService.priorityUpdateModal.userNames.length > 0 ? "For User(s): " + userService.priorityUpdateModal.userNames : ''}} </h5>
        <a (click)="userService.closePriorityUpdateModal()"><i class="fa-light fa-xmark"></i></a>
    </div>
    <div class="footer-sidepanel__content">
      <div class="  form-wrapper-compact">
        <div class="flex-row">
          <div class="flex-col-sm-12">
            <section class="section form-wrapper-compact">
              <div class="section__content">
                
                <div class=" mb-10">
                  <!-- <div class="form-info mb-10"> -->
                    <!-- <h5 class="form-info__title">Campaign Program</h5> -->
                    <!-- <p class="form-info__content">Update your campaign program and details here.</p> -->
                  <!-- </div> -->
                  <div class="address-form">
                    <form
                      [formGroup]="userService.userPriorityForm"
                      class="form-fields  form-container "
                    >
                      <div class="flex-row flex-row--compact">
                        <div class="flex-col-sm-12">
                          <div class="single-input-field-wrapper">
                            <label for="fname" class="form-fields__label">Priority</label>
                            <!-- Dropdown List -->
                            <div class="dropdown-list-wrapper">
                              <div class="dropdown-list" >
                                <f-dropdown
                                  [ngStyle]="{ width: '100%', height: '100%' }"
                                  [style]="{ width: '100%', height: '100%' }"
                                  formControlName="priority"
                                  placeholder="Select priority"
                                  display="chip"
                                  optionLabel="lable"
                                  name="priority"
                                  optionValue="value"
                                  [options]="userService.priorityDropDown"
                                  [leftIconClass]="'fa-thin fa-buildings'"
                                >
                                </f-dropdown>
                              </div>
                            </div>
                            @if (userService.checkPriorityFormFieldValidation("priority")) {
                            <div class="validation validation--error">Please provide priority.</div>
                            }
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
            <section class="section">
              <div class="section__content">
                <div class="flex-row flex-row--no-pad">
                  <div class="flex-col-sm-12">
                    <div class="form-secondary-header">
                      <div class="form-actions">
                        <!-- Single-Button -->
                        <a (click)="userService.closePriorityUpdateModal()" class="single-button--without-bg" style="margin-right: 10px;">Cancel</a>
                        <a (click)="userService.onUpdateUserPriority()" class="single-button--with-bg">Update</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      
    </div>
</aside>